import { useEffect } from "react";
import { useHistory } from "react-router-dom";

function Finish() {
  const history = useHistory();

  useEffect(() => {
    history.push(`/register/info`);
  }, [history]);

  return null;
}

export default Finish;
